import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, propTypes as formPropTypes } from 'redux-form';
import cloneDeep from 'lodash/cloneDeep';
import DateTimePicker from '../../common/components/DateTimePicker';
import ReduxFormsField from '../../common/forms/ReduxFormsField';
import ReduxFormsDateTimePicker from '../../common/forms/ReduxFormsDateTimeField';
import TwoStepButton from '../../common/components/TwoStepButton';
import CropperScaffold from '../../common/forms/CropperScaffold';
import ReduxFormsImageCropper from '../../common/forms/ReduxFormsImageCropper';
import VideoUploader from '../../common/components/VideoUploader';

const validate = values => {
  const errors = {};
  const { name, description, publish_at } = values;

  if (!name || !name.trim()) {
    errors.name = ['Name is required'];
  } else if (name.trim().length > 255) {
    errors.name = ['Name cannot be longer than 255 characters'];
  }

  if (!description || !description.trim()) {
    errors.description = ['Description is required'];
  } else if (description.trim().length > 255) {
    errors.description = ['Description cannot be longer than 255 characters'];
  }

  if (!publish_at) errors.publish_at = ['Publish date and time are required'];

  return errors;
};

class TvEpisodeEditForm extends Component {
  static propTypes = {
    ...formPropTypes,
    clearOrigImage: PropTypes.bool,
    episode: PropTypes.object,
    episodeUploading: PropTypes.bool,
    episodeUploadProgress: PropTypes.object,
    onCancel: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onVideoUpload: PropTypes.func.isRequired,
    removeImage: PropTypes.func,
  };

  onSubmit = values => {
    const submitValues = cloneDeep(values);
    submitValues.name = submitValues.name.trim();
    submitValues.description = submitValues.description.trim();

    return this.props.onSubmit(submitValues);
  };

  render() {
    const {
      clearOrigImage,
      episode,
      episodeUploading,
      episodeUploadProgress,
      handleSubmit,
      onCancel,
      onDelete,
      onVideoUpload,
      removeImage,
      submitting,
    } = this.props;

    return (
      <div className="admin-paper__edit-content">
        <form onSubmit={handleSubmit(this.onSubmit)}>
          <Field name="name" component={ReduxFormsField} label="Name" required={true}>
            <input type="text" />
          </Field>
          <Field name="description" component={ReduxFormsField} label="Description" required={true}>
            <input type="text" />
          </Field>
          <Field
            className="admin__publish-date"
            name="publish_at"
            component={ReduxFormsDateTimePicker}
            label="Publish Date"
            required={true}
          >
            <DateTimePicker />
          </Field>
          <VideoUploader
            labelText="Episode Video"
            onVideoUpload={onVideoUpload}
            uploading={episodeUploading}
            uploadProgress={episodeUploadProgress}
            video={episode.get('video_id') ? episode.get('video') : null}
          />
          {episode && episode.get('image_id') && !clearOrigImage ? (
            <CropperScaffold label="Episode Image" required>
              <div className="original-image">
                <img alt="episode logo" src={episode.getIn(['image', 'location'])} />
              </div>
              <div className="cropper-scaffold__controls">
                <button type="button" className="button button--theme--outline" onClick={removeImage}>
                  Remove Image
                </button>
              </div>
            </CropperScaffold>
          ) : (
            <Field name="image" component={ReduxFormsImageCropper} label="Episode Image" required={true} />
          )}
          <div className="admin-paper__edit-content__button-row">
            <div>
              <TwoStepButton
                buttonText="Delete Episode"
                className="button"
                onConfirm={onDelete}
                disabled={submitting}
              />
            </div>
            <div>
              <button type="button" className="button button--theme--plain" onClick={onCancel} disabled={submitting}>
                Cancel
              </button>
              <button type="submit" className="button" disabled={submitting}>
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'tvEpisodeEditForm',
  onSubmitFail: () => {
    window.scrollTo(0, 0);
  },
  validate,
})(TvEpisodeEditForm);



// WEBPACK FOOTER //
// ./src/tv/episodes/TvEpisodeEditForm.js